module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_5012.f4013078.png";